// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__HSf5L","tooltip-arrow":"Tooltip_tooltip-arrow__ywJCr"};